import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
//

import DashboardSidebar from '../dashboard/DashboardSidebar';
import DashboardNavbar from '../dashboard/DashboardNavbar';
import DashboardSidebarOrg from '../dashboard/DashboardSidebarOrg';
import HomeNavbar from '../home/HomeNavbar';
import { Variables } from '../../context/VariableContext';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 70;

const RootStyle = styled('div')({
  display: 'flex',
  // minHeight: '100%',
  backgroundColor: 'white',
  overflowX: 'hidden',
  overflowY: 'visible',
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  position: 'relative',
  overflowY: 'auto',
  overflowX: 'hidden',
  // minHeight: '100%',
  paddingTop: APP_BAR_MOBILE,
  backgroundColor: 'white',
  // paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP,
  }
}));

// ----------------------------------------------------------------------

export default function CrmLayout() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const { hideNavbar, setHideNavbar } = Variables();

  useEffect(() => {
    const path = location.pathname;
    const shouldHide = /^\/marketing\/ads\/[a-zA-Z0-9]+$/.test(path); // détecte /marketing/ads/:id
    setHideNavbar(shouldHide);
  }, [location]);

  return (
    <RootStyle>
      {
        hideNavbar === false && <HomeNavbar />
      }
      <MainStyle>
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}
